import { Card } from 'flowbite-react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Unauthorized() {
    const { t } = useTranslation("errors");
    return (
        <Card>
            <Trans t={t}>unauthorized</Trans>
            <Link to={"/login"}><Trans t={t}>login</Trans></Link>
        </Card>
    )
}